// src/components/routes/ProtectedRoutedata.js
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../Header/header";

const ProtectedRoutedata = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    if (!token) {
      // Redirect to login if token is missing
      navigate("/login/sib", { replace: true });
    }
  }, [navigate]);

  // Render only if token exists
  const token = sessionStorage.getItem("access_token");
  if (!token) return null;

  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default ProtectedRoutedata;
